<template>
    <img v-if="name === 'white'" class="logo h-auto" :src="getWhiteLogoSrc()"  alt="Logo">
    <img v-else class="logo h-auto" :src="getLogoSrc()" alt="Logo" />
</template>
<script>
export default {
    props: {
        name: String,
    },
    methods: {
    getWhiteLogoSrc() {
        const user = this.$page.props?.auth?.user;
        const logo_white = user?.project?.logo_white;
        const favicon_logo = user?.project?.favicon;
      if (user?.role.id === 4 && logo_white) {
        const favicon = document.querySelector('link[rel="icon"]');
        favicon.href = favicon_logo;
        return logo_white;
      } else {
        return '/images/logo_white.png';
      }
    },
    getLogoSrc() {
        const user = this.$page.props?.auth?.user;
        const logo = user?.project?.logo;
        const favicon_logo = user?.project?.favicon;

      if (user?.role.id === 4 && logo) {
        const favicon = document.querySelector('link[rel="icon"]');
        favicon.href = favicon_logo;
        return logo;
      } else {
        return '/images/logo.png';
      }
    },
  },
}
</script>
